import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Sparkle, User } from '@phosphor-icons/react';
import ReactMarkdown from 'react-markdown';
interface ChatMessageProps {
  role: 'user' | 'assistant';
  content: string;
  timestamp: Date;
  isStreaming?: boolean;
}
export function ChatMessage({
  role,
  content,
  timestamp,
  isStreaming = false
}: ChatMessageProps) {
  const isUser = role === 'user';
  const [isExpanded, setIsExpanded] = useState(false);
  // Check if user message is long (more than 100 characters)
  const isLongMessage = isUser && content.length > 100;
  const shouldCollapse = isLongMessage && !isExpanded;
  return <motion.div initial={{
    opacity: 0,
    y: 10
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.3,
    ease: [0.23, 1, 0.32, 1]
  }} className={`flex gap-3 ${isUser ? 'justify-end' : 'justify-start'}`} data-id="element-205">
      {!isUser && <div className="flex-shrink-0 w-8 h-8 rounded-full bg-white/10 flex items-center justify-center" data-id="element-206">
          <Sparkle className="w-4 h-4 text-white" data-id="element-207" />
        </div>}

      <div className={`flex flex-col ${isUser ? 'items-end' : 'items-start'} max-w-[80%]`} data-id="element-208">
        <div className={`px-4 py-3 rounded-2xl ${isUser ? 'bg-white text-black' : 'bg-white/5 text-white border border-white/10'} ${isLongMessage ? 'cursor-pointer transition-colors' : ''}`} onClick={() => isLongMessage && setIsExpanded(!isExpanded)} data-id="element-209">
          <p className={`text-sm leading-relaxed whitespace-pre-wrap ${shouldCollapse ? 'line-clamp-1' : ''}`} data-id="element-210">
            {content}
            {isStreaming && <motion.span animate={{
            opacity: [0, 1, 0]
          }} transition={{
            duration: 1,
            repeat: Infinity
          }} className="inline-block w-1 h-4 ml-1 bg-current" data-id="element-211" />}
          </p>
          {isLongMessage && <button className="flex items-center gap-1 mt-1 text-xs opacity-60 hover:opacity-100 transition-opacity" data-id="element-212">
              <CaretDown className={`w-3 h-3 transition-transform ${isExpanded ? 'rotate-180' : ''}`} data-id="element-213" />
            </button>}
        </div>
        <span className="text-xs text-white/40 mt-1 px-1" data-id="element-214">
          {timestamp.toLocaleTimeString([], {
          hour: '2-digit',
          minute: '2-digit'
        })}
        </span>
      </div>

      {isUser && <div className="flex-shrink-0 w-8 h-8 rounded-full bg-white/10 flex items-center justify-center" data-id="element-215">
          <User className="w-4 h-4 text-white" data-id="element-216" />
        </div>}
    </motion.div>;
}